import axiosClient from './axiosClient'

const roleApi = {
  create: params => axiosClient.post('roles', params),
  getAll: () => axiosClient.get('roles'),
  delete: (id) => axiosClient.delete(`roles/${id}`),
  update: (id, params) => axiosClient.put(`roles/${id}`, params),
}

export default roleApi